import { ReactNode } from "react";
import { AppContextProvider } from "../contexts/AppContext";
import {
  UserContextProvider,
  GameContextProvider,
  ThemeContextProvider,
  StartupContextProvider,
  NotificationContextProvider,
} from "../modules";
import { BaseCacheContextProvider } from "../modules/base/contexts";
import { GlobalDataContextProvider } from "../contexts/GlobalDataContext/index.tsx";

// 应用提供者Props
interface AppProviderProps {
  children: ReactNode;
}

// 应用提供者组件
export function AppProvider({ children }: AppProviderProps) {
  return (
    <BaseCacheContextProvider>
      <StartupContextProvider>
        <GlobalDataContextProvider>
          <UserContextProvider>
            <ThemeContextProvider>
              <GameContextProvider>
                <NotificationContextProvider>
                  <AppContextProvider>{children}</AppContextProvider>
                </NotificationContextProvider>
              </GameContextProvider>
            </ThemeContextProvider>
          </UserContextProvider>
        </GlobalDataContextProvider>
      </StartupContextProvider>
    </BaseCacheContextProvider>
  );
}

export default AppProvider;
